<script setup lang="ts">
const props = defineProps<{
  value: boolean
}>()
</script>

<template>
  <v-icon :icon="props.value ? 'check_box' : 'check_box_outline_blank'" />
</template>

<style scoped lang="scss"></style>
